import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const SCRIPT_ID = 'awin-mastertag';

/**
 * Routes où le MasterTag ne doit pas être injecté (gestion Stripe / paiements hors checkout).
 * Le checkout charge le MasterTag : exigé par Awin pour éviter « MasterTag manquant » sur les conversions.
 * @see https://help.awin.com/docs/advertiser-mastertag
 */
export const isPaymentSensitivePathForAwin = pathname => {
  if (!pathname) {
    return false;
  }
  if (pathname === '/payment-methods' || pathname.startsWith('/account/payment-methods')) {
    return true;
  }
  if (pathname === '/payout' || pathname.startsWith('/payments/')) {
    return true;
  }
  if (pathname === '/account/payments' || pathname.startsWith('/account/payments/')) {
    return true;
  }
  // Retour Stripe Connect depuis l’édition d’annonce (/product/.../edit/payout/success|failure)
  if (/^\/product\/[^/]+\/[^/]+\/[^/]+\/[^/]+\/[^/]+\/[^/]+$/.test(pathname)) {
    return true;
  }
  return false;
};

/**
 * MasterTag Awin : cookie first-party et tracking affiliés.
 * Chargé en fin de document.body (append) avec defer, retiré sur les routes sensibles (pas le checkout).
 */
const AwinMasterTag = () => {
  const { pathname } = useLocation();
  const advertiserId = process.env.REACT_APP_AWIN_ADVERTISER_ID || '126415';

  useEffect(() => {
    if (typeof document === 'undefined' || process.env.NODE_ENV === 'test') {
      return;
    }

    const src = `https://www.dwin1.com/${advertiserId}.js`;
    const existing = document.getElementById(SCRIPT_ID);
    const exclude = !advertiserId || isPaymentSensitivePathForAwin(pathname);

    if (exclude) {
      if (existing) {
        existing.remove();
      }
      return;
    }

    if (existing && existing.src === src) {
      return;
    }

    if (existing) {
      existing.remove();
    }

    const script = document.createElement('script');
    script.id = SCRIPT_ID;
    script.type = 'text/javascript';
    script.defer = true;
    script.setAttribute('defer', 'defer');
    script.src = src;
    document.body.appendChild(script);
  }, [pathname, advertiserId]);

  return null;
};

export default AwinMasterTag;
